import {Box, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";

export function BackSetitngButton({label}) {
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => navigate(-1)}
      display="flex"
      marginY={"16px"}
      marginLeft={"18px"}
      alignItems="center"
      gap={"12px"}
      style={{cursor: "pointer"}}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.8337 7.00033H1.16699M1.16699 7.00033L7.00033 12.8337M1.16699 7.00033L7.00033 1.16699"
          stroke="#EDA044"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <Typography fontWeight={600} color={"#EDA044"}>
        {label}
      </Typography>
    </Box>
  );
}
